import React from "react";
import styled from "styled-components";
import IconTooltip from "../../assets/images/icon-tooltip.png";
import { Mobile, Pc, Tablet } from "../../hooks/useMediaQuery";
import DriverTooltips from "./DriverTooltips";
import InnerSection from "./Layout/InnerSection";
import Section from "./Layout/Section";
import Table from "./Table/Table";
import SubTitle from "./Text/SubTitle";
function TeamSystemContainer({ children }) {
  return (
    <Section padding="100px 0" background="#FAFAFA">
      <InnerSection>
        <SubTitle fontSize="40" data-aos="fade-up" data-aos-duration="1000">
          연간모시러 구독 상품
        </SubTitle>
        <TableContainer data-aos="fade-up" data-aos-duration="1000">
          <Table>
            <colgroup>
              <Pc>
                <col style={{ width: `200px` }} />
              </Pc>
              <Tablet>
                <col style={{ width: `200px` }} />
              </Tablet>
              <Mobile>
                <col style={{ width: `120px` }} />
              </Mobile>
              <col />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th>상품</th>
                <th>100시간</th>
                <th>200시간</th>
                <th>300시간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>기본시간</th>
                <td>100시간</td>
                <td>200시간</td>
                <td>300시간</td>
              </tr>
              <tr>
                <th>최소 이용 시간</th>
                <td>8</td>
                <td>8</td>
                <td>8</td>
              </tr>
            </tbody>
          </Table>
        </TableContainer>
      </InnerSection>
      <DriverTooltips />
    </Section>
  );
}
const TableContainer = styled.div`
  margin-top: 40px;
  @media (max-width: 640px) {
    margin-top: 24px;
  }
`;
const ButtonTooltip = styled.button`
  background: transparent;
  width: 18px;
  outline: none;
  border: none;
  vertical-align: middle;
  cursor: pointer;
`;
const Image = styled.img`
  width: 100%;
`;
export default TeamSystemContainer;
